import classNames from "classnames";
import type { FC, ReactNode } from "react";

import styles from "./_.module.css";

export type PopOverMenuItemProps = {
	className?: string;
	borderBefore?: boolean;
	borderAfter?: boolean;
	children: ReactNode;
};

export const PopOverMenuItem: FC<PopOverMenuItemProps> = ({
	borderBefore,
	borderAfter,
	className,
	children,
}) => {
	const Border = () => (
		<li className={"my-1 shadow-border-default"} style={{ height: "1px" }} aria-hidden></li>
	);
	return (
		<>
			{borderBefore && <Border />}
			<li className={classNames(styles["popovermenuitem"], className)}>{children}</li>
			{borderAfter && <Border />}
		</>
	);
};
